import { Link } from 'react-router-dom';
import { videoCategories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-300/30">
      <div className="container-site py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4" aria-label="妖精视频首页">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-circle-fill text-background-50 text-xl" style={{ width: '20px', height: '20px' }}></i>
              </div>
              <span className="text-xl font-bold text-foreground-950 font-heading whitespace-nowrap">
                妖精视频
              </span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed">
              免费在线视频平台，聚合海量高清影视资源，无需下载不缓冲，即点即播畅享观影体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 whitespace-nowrap">视频分类</h4>
            <ul className="space-y-2">
              {videoCategories.slice(0, 4).map(cat => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 whitespace-nowrap">更多分类</h4>
            <ul className="space-y-2">
              {videoCategories.slice(4).map(cat => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap"
                >
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 whitespace-nowrap">联系我们</h4>
            <ul className="space-y-2 text-sm text-foreground-500">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-500"></i>
                <span>contact@yaojingvideo.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-primary-500"></i>
                <span>400-888-8888</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-primary-500"></i>
                <span>北京市朝阳区建国路88号</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-300/30 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 妖精视频 YaolingVideo.com 版权所有 | <strong>免费在线观看</strong> | <strong>高清电视剧</strong> | <strong>电影大全</strong>
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}